import {Component, HostListener} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../core/services/common.service";
import {HttpClientService} from "../../core/services/http-client.service";
import {ToastService} from "../../core/services/toast.service";
import { Carousel } from 'primeng/carousel';
declare var window: any;
declare var document: any;

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent {
  loading: boolean = true;
  visible: boolean = false;
  welcomeDialog: boolean = false;
  pincode: any;
  cart: any;
  banners: any[] = [];
  brands: any[] = [];
  webListings: any[] = [];
  responsiveOptions: any[] | undefined;
  brandOptions: any[] | undefined;
  isFetchingListings: boolean = false;
  private hasScrolled: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private common: CommonService, private http: HttpClientService, private toast: ToastService) {
    Carousel.prototype.onTouchMove = () => { };
  }

  ngOnInit() {
    this.getBannersList();
    this.responsiveOptions = [
      {
        breakpoint: '1400px',
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: '1199px',
        numVisible: 3,
        numScroll: 2,
      },
      {
        breakpoint: '767px',
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: '575px',
        numVisible: 2,
        numScroll: 2,
      },
    ];
    this.brandOptions = [
      {
        breakpoint: '1400px',
        numVisible: 12,
        numScroll: 4,
      },
      {
        breakpoint: '1199px',
        numVisible: 12,
        numScroll: 4,
      },
      {
        breakpoint: '767px',
        numVisible: 9,
        numScroll: 4,
      },
      {
        breakpoint: '575px',
        numVisible: 4,
        numScroll: 4,
      },
    ];
    if(this.common.getStorage("hasWaited") == null) this.common.setStorage("hasWaited",true);
    setTimeout(() => {
      this.showDialog();
    }, 5000);
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    if (scrollY > 150) { // adjust as needed
      this.hasScrolled = true;
      this.showDialog();
    }
  }

  async getBannersList() {
    this.route.data.subscribe((res)=>{
      this.banners = res.banners.response;
    });
    if (this.common.getToken() != null) {
      this.getFofoBrands();
      this.getFofoListing();
    } else {
      setTimeout(() => {
        this.getBannersList();
      }, 2000);
    }
  }

  getFofoListing() {
    this.isFetchingListings = true;
    this.http.get('store/listing').subscribe((data) => {
      this.webListings = data.response.filter((category) => category.fofoCatalogResponses.length > 0);
      // Filter out out-of-stock items for each category
      this.webListings.forEach((category) => {
        category.fofoCatalogResponses = category.fofoCatalogResponses.filter(
          (item) => item.items[0].availability > 0
        );
      });
      this.loading = false;
      this.isFetchingListings = false;
    }, error => {this.loading = false;
      this.isFetchingListings = false;
    });
  }

  getFofoBrands() {
    this.http.get("fofo/brands/?"+this.common.stringParams({ categoryId: "3" })).subscribe(
      (data) => {
        const preferredOrder = ['Samsung', 'Apple', 'Vivo'];
        data = data.filter(el => { return ('logoUrl' in el) && el.logoUrl.trim() != ""});
        this.brands = data.sort((a, b) => {
          const rankA = preferredOrder.indexOf(a.name);
          const rankB = preferredOrder.indexOf(b.name);
          if (rankA !== -1 && rankB !== -1) {
            return rankA - rankB;
          }
          if (rankA !== -1) return -1;
          if (rankB !== -1) return 1;
          return b.brandCategory.rank - a.brandCategory.rank;
        });
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.toast.error("Server Error!")
      }
    );
  }

  refresh() {
    this.isFetchingListings = true;
    window.location.reload();
  }

  navigateToPage(page) {
    this.router.navigateByUrl(`/products/${page}`);
  }

  closeDialog() {
    this.common.setStorage("hasWaited",false);
    this.welcomeDialog = false;
  }

  private showDialog() {
    const hasWaited = this.common.getStorage("hasWaited");
    if (this.hasScrolled && hasWaited) {
      this.welcomeDialog = true;
    }
  }

  async openUrl(url: string){
    await this.common.openInBrowser(url);
  }
}
